import React, {useState, useEffect, useImperativeHandle} from "react";
import axios from "axios";
import { ButtonsFooter } from "../Components/Atoms/ButtonFooter";
import { InputSelectListCardContainer } from "../Components/InputSelectListCard/InputSelectListCardContainer";
import { SwitchListCard } from "../Components/InputListCard/SwitchListCard";

export const withEditableInfo = (
  Component,
  cardName,
  imageName,
  profileId,
  itemList1,
  companyDifferentiatorsMap,
  workingHours,
  itemList2,
  switchList1,
  itemList3,
  switchList2,
  itemList4,
  imageUrl,
  authToken,
  urlApi,
  authEpid,
  cancelActionHandler,
  saveActionHandler,
  refreshProfile,
  setopenInprogress,
  ref
) => {
  return (props) => {
    const config = {
      headers: { accept: "*/*", Authorization: `Bearer ${authToken}` },
    };
    const [changed, setChanged] = useState(false);
    const [companyInfoChanges, setCompanyInfoChanges] = useState();
    const [workingHoursState, setWorkingHoursState] = useState(workingHours);
    const [switchList1State, setSwitchList1State] = useState(switchList1);
    const [switchList2State, setSwitchList2State] = useState(switchList2);
    const isChanged = () => {
      return changed;
    }

    const onChangeCompanyInfo = (changes) => {
      setChanged(true);
      if (changes.workingHours) {
        const workingHoursTmp = workingHoursState.reduce(
          (acc, currentValue) =>
            changes.workingHours[0].weekDay === currentValue.weekDay
              ? [...acc, changes.workingHours[0]]
              : [...acc, currentValue],
          []
        );
        const tmp = {
          workingHours: workingHoursTmp,
        };
        setWorkingHoursState(tmp.workingHours);
        if (workingHours !== workingHoursState) {
          setCompanyInfoChanges({ ...companyInfoChanges, ...tmp });
        }
      } else if (changes.ebokServicesList) {
        const tmp = { ebokServicesList: [changes.ebokServicesList] };
        setCompanyInfoChanges({ ...companyInfoChanges, ...tmp });
      } else {
        setCompanyInfoChanges({ ...companyInfoChanges, ...changes });
      }
    };

    const onSaveCompanyInfo = async () => {
      const switchList1Changes = {
        ...(switchList1State["Czy jest miejsce na rower"] !== undefined && {
          placeForBike: switchList1State["Czy jest miejsce na rower"],
        }),
        ...(switchList1State["Czy jest miejsce na pieska"] !== undefined && {
          placeForDog: switchList1State["Czy jest miejsce na pieska"],
        }),
        ...(switchList1State["Czy jest poczekalnia"] !== undefined && {
          waitingRoom: switchList1State["Czy jest poczekalnia"],
        }),
        ...(switchList1State["Czy jest klimatyzacja"] !== undefined && {
          airConditioning: switchList1State["Czy jest klimatyzacja"],
        }),
        ...(switchList1State["Czy oferowane są napoje"] !== undefined && {
          drinks: switchList1State["Czy oferowane są napoje"],
        }),
        ...(switchList1State["Czy jest obsługa w języku obcym"] !==
          undefined && {
          foreignLanguage: switchList1State["Czy jest obsługa w języku obcym"],
        }),
      };

      const switchList2Changes = {
        ...(switchList2State[
          "Czy jest możliwy kontakt telefoniczny po godzinach pracy biura"
        ] !== undefined && {
          supportAfterHours:
            switchList2State[
              "Czy jest możliwy kontakt telefoniczny po godzinach pracy biura"
            ],
        }),
        ...(switchList2State["Czy można zgłaszać usterki"] !== undefined && {
          supportAvailable: switchList2State["Czy jest miejsce na pieska"],
        }),
        ...(switchList2State["Czy można zamówić usługi"] !== undefined && {
          ordersAvailable: switchList2State["Czy można zamówić usługi"],
        }),
      };

      if (companyInfoChanges || switchList1Changes || switchList2Changes) {
        const payload = {
          id: profileId,
          ePid: authEpid,
          ...companyInfoChanges,
          ...switchList1Changes,
          ...switchList2Changes,
        };
        setopenInprogress(true);
        const result = await axios.patch(urlApi, payload, config);
      }
      setopenInprogress(false);
      refreshProfile();
      saveActionHandler();
      setChanged(false);
    };

    const onChangeSwitchList1 = (changes) => {
        setChanged(true);
        setSwitchList1State({ ...switchList1State, ...changes });
    };

    const onChangeSwitchList2 = (changes) => {
      setChanged(true);
      setSwitchList2State({ ...switchList2State, ...changes });
    };
      useImperativeHandle(ref, () => ({
          save: onSaveCompanyInfo,
          isChanged: isChanged
      }));

      const INPUTLISTCARD1 = 1;
      const INPUTLISTCARD2 = 2;
      const INPUTLISTCARD4 = 4;
      const INPUTLISTCARD6 = 6;

      const onComponentIsComplete = (componentId) => {
          console.debug('ComponentIsComplete', componentId);
      }

    return (
      <InputSelectListCardContainer
        cardName={cardName}
        inputListCard1={
          <Component
            itemList={itemList1}
            selectItemList={workingHours}
            onChangeActionHandler={onChangeCompanyInfo}
            emitComponentIsComplete={() => {onComponentIsComplete(INPUTLISTCARD1)}}
          />
        }
        inputListCard2={
          <Component
            itemList={itemList2}
            selectItemList={null}
            onChangeActionHandler={onChangeCompanyInfo}
            emitComponentIsComplete={() => {onComponentIsComplete(INPUTLISTCARD2)}}
          />
        }
        inputListCard3={
          <SwitchListCard
            objectToUpdate={switchList1State}
            onChangeServices={onChangeSwitchList1}
          />
        }
        inputListCard4={
          <Component
            itemList={itemList3}
            selectItemList={null}
            onChangeActionHandler={onChangeCompanyInfo}
            emitComponentIsComplete={() => {onComponentIsComplete(INPUTLISTCARD4)}}
          />
        }
        inputListCard5={
          <SwitchListCard
            objectToUpdate={switchList2State}
            onChangeServices={onChangeSwitchList2}
          />
        }
        inputListCard6={
          <Component
            itemList={itemList4}
            selectItemList={null}
            onChangeActionHandler={onChangeCompanyInfo}
            emitComponentIsComplete={() => {onComponentIsComplete(INPUTLISTCARD6)}}
          />
        }
        buttonsFooter={
          <ButtonsFooter
            saveActionHandler={onSaveCompanyInfo}
            cancelActionHandler={cancelActionHandler}
          />
        }
      />
    );
  };
};
